"use client";

import type { ComponentProps } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function FilterSegmentInput({
  options,
  value,
  onChange,
  "aria-label": ariaLabel,
  ...props
}: ComponentProps<typeof Tabs> & {
  options: string[];
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <Tabs value={value} onValueChange={onChange} variant="search" {...props}>
      <TabsList className="w-full" aria-label={ariaLabel}>
        {options.map((opt) => (
          <TabsTrigger key={opt} value={opt}>
            {opt}
          </TabsTrigger>
        ))}
      </TabsList>
    </Tabs>
  );
}
